<template>
  <vx-application />
</template>
<script>
import VxApplication from '@/wikaz-core/ui/VxApplication'
export default {
    name: 'App',
    components: { VxApplication },
}
</script>